import Moment from 'moment';

export const formatDate = (date: string | Date, format?: string) => (date ? Moment(date).format(format || 'DD.MM.YYYY HH:mm') : '');
export const formatDateOnly = (date: string | Date, format?: string) => (date ? Moment(date).format(format || 'DD.MM.YYYY') : '');
